import { useSetAtom } from 'jotai'
import React from 'react'

import { HStack } from '~/components/elements/HStack'
import {
  TooltipButton,
  type TooltipButtonProps,
} from '~/components/elements/TooltipButton'
import { Typography } from '~/components/elements/Typography'
import { type BrandGroup } from '~/hooks/useSurveyForSettingsQuery'

import { dialogInfoAtom } from '../atoms'

export type NameCellProps = {
  dataItem: BrandGroup
}

export const NameCell = ({ dataItem: brandGroup }: NameCellProps) => {
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleEditButtonClick = React.useCallback<
    EH<TooltipButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'update', brandGroup })
  }, [brandGroup, setDialogInfo])

  return (
    <td>
      <HStack
        align="center"
        backgroundColor="transparent"
        justify="space-between"
        spacing={2}
      >
        <Typography fontSize={14} variant="normal">
          {brandGroup.name}
        </Typography>

        <TooltipButton
          fillMode="flat"
          icon="edit"
          title="Edit"
          onClick={handleEditButtonClick}
        />
      </HStack>
    </td>
  )
}
